import type { Ref } from "react";
import { Avatar, type AvatarSize } from "./Avatar";

export interface WorkspaceAvatarWorkspace {
    name: string;
    iconColor: string | null;
}

export interface WorkspaceAvatarProps {
    workspace: WorkspaceAvatarWorkspace;
    size?: AvatarSize;
    className?: string;
    /** Set when the workspace's name is visible next to the avatar. */
    "aria-hidden"?: boolean;
    ref?: Ref<HTMLSpanElement>;
}

/**
 * A workspace (client) as a square with the initial of its name on
 * its `iconColor`, or outlined when it has no colour.
 */
export const WorkspaceAvatar = ({
    workspace,
    size,
    className,
    "aria-hidden": isAriaHidden,
    ref,
}: Readonly<WorkspaceAvatarProps>) =>
    workspace.iconColor === null ? (
        <Avatar
            ref={ref}
            name={workspace.name}
            shape="square"
            variant="outline"
            tone="neutral"
            size={size}
            className={className}
            aria-hidden={isAriaHidden}
        />
    ) : (
        <Avatar
            ref={ref}
            name={workspace.name}
            shape="square"
            color={workspace.iconColor}
            size={size}
            className={className}
            aria-hidden={isAriaHidden}
        />
    );
